import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VuetifyConfirm from "vuetify-confirm";
import OktaVue from "@okta/okta-vue";
import { toRelativeUrl } from "@okta/okta-auth-js"
import oktaAuth from "@/okta";
import numeral from "numeral";
import "./mixins/utils";

oktaAuth.options.restoreOriginalUri = async (_oktaAuth, originalUri) => {
  const redirectPath = toRelativeUrl(originalUri || "/", window.location.origin);

  if (router.currentRoute.fullPath !== redirectPath) {
    await router.replace(redirectPath);
  }
}

Vue.use(OktaVue, {
  oktaAuth,
  onAuthRequired: () => {
    if (router.currentRoute.name !== "login") {
      router.push({ name: "login" });
    }
  },
})

Vue.use(OktaVue, { oktaAuth });

Vue.use(VuetifyConfirm, {
  vuetify,
  buttonFalseColor: "primary",
});

Vue.config.productionTip = false;

Vue.filter("formatNumber", (number) => {
  return numeral(number).format("0,0.0");
});

Vue.mixin({
  data: function () { return { attrs$: { "data-lpignore": "true" } } }
})

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
